"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTournamentsActionLogsListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsActionLogsListCtl, _super);
    function BonusTournamentsActionLogsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_action_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.action_amount; });
        _this.dk_action_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.action_type_code; });
        _this.dk_action_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.action_type_title; });
        _this.dk_tournament_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_balance_before; });
        _this.dk_tournament_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_balance_after; });
        _this.dk_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_before; });
        _this.dk_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_after; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsActionLogsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsActionLogsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    BonusTournamentsActionLogsListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListBonusTournamentActionsByTournamentSessionIdGet.exec({
            tournament_session_id: data.tournamentSessionId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            limit: data.limit,
            offset: data.offset
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    action_amount: resp.list[i].action_amount,
                    action_type_code: resp.list[i].action_type_code,
                    action_type_title: resp.list[i].action_type_title,
                    tournament_balance_before: resp.list[i].tournament_balance_before,
                    tournament_balance_after: resp.list[i].tournament_balance_after,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BonusTournamentsActionLogsListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsActionLogsListCtl = BonusTournamentsActionLogsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentActionLogsListCtl.ts
// module id = 2127
// module chunks = 0